<div class="spinner-container" *ngIf="spinnerActive">
    <p-progressSpinner></p-progressSpinner>
</div>